export default "__VITE_ASSET__$S8SDPyQ__"